<div style="padding: 20px 22px; max-width: 780px;">

  <h2 style="margin: 0 0 4px; font-size: 1.05rem; font-weight: 700; color: #111827;">
    Emparejar con un movimiento de N58
  </h2>
  <p style="margin: 0 0 16px; font-size: 0.82rem; color: #6b7280;">
    Elegí el movimiento del banco que corresponde a esta referencia. Se acredita al cliente
    y se concilia el movimiento en un solo paso.
  </p>

  <!-- Lo que declaró el cliente -->
  <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 12px 14px; margin-bottom: 16px;">
    <div style="display: flex; flex-wrap: wrap; gap: 18px; font-size: 0.82rem;">
      <div>
        <div style="color: #9ca3af; font-size: 0.7rem; text-transform: uppercase; letter-spacing: .4px;">Referencia del cliente</div>
        <div style="font-weight: 700; color: #111827;">{{ referencia?.referencia }}</div>
      </div>
      <div>
        <div style="color: #9ca3af; font-size: 0.7rem; text-transform: uppercase; letter-spacing: .4px;">Monto declarado</div>
        <div style="font-weight: 700; color: #111827;">{{ formatVES(referencia?.monto) }}</div>
      </div>
      <div>
        <div style="color: #9ca3af; font-size: 0.7rem; text-transform: uppercase; letter-spacing: .4px;">Titular</div>
        <div style="font-weight: 600; color: #374151;">{{ referencia?.titular || '-' }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="cargando" style="padding: 26px; text-align: center; color: #6b7280; font-size: 0.85rem;">
    Buscando movimientos en N58…
  </div>

  <ng-container *ngIf="!cargando">

    <!-- Candidatos con monto exacto: los únicos emparejables -->
    <div *ngIf="emparejables.length > 0">
      <div style="font-size: 0.75rem; font-weight: 700; color: #16a34a; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 8px;">
        Movimientos por el monto exacto ({{ emparejables.length }})
      </div>

      <div *ngFor="let c of emparejables"
        (click)="seleccionar(c.id)"
        [style.border]="seleccionado === c.id ? '2px solid #16a34a' : '1px solid #e5e7eb'"
        [style.background]="seleccionado === c.id ? '#f0fdf4' : '#ffffff'"
        style="border-radius: 8px; padding: 11px 13px; margin-bottom: 8px; cursor: pointer;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;">
          <div style="min-width: 0;">
            <div style="font-weight: 700; color: #111827; font-size: 0.85rem;">
              Ref. banco {{ c.referenciaBanco || '(sin referencia)' }}
            </div>
            <div style="font-size: 0.76rem; color: #6b7280; margin-top: 2px;">
              {{ c.descripcion }} <span *ngIf="c.concepto">· {{ c.concepto }}</span>
            </div>
            <div *ngIf="c.contraparte" style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
              {{ c.contraparte }}
            </div>
          </div>
          <div style="text-align: right; white-space: nowrap;">
            <div style="font-weight: 800; color: #16a34a; font-size: 0.88rem;">{{ formatVES(c.monto) }}</div>
            <div style="font-size: 0.72rem; color: #9ca3af;">{{ c.fecha | date:'short' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="emparejables.length === 0"
      style="border: 1px solid #fde68a; background: #fffbeb; border-radius: 8px; padding: 13px 15px; font-size: 0.82rem; color: #92400e;">
      <strong>No hay ningún movimiento sin conciliar por {{ formatVES(referencia?.monto) }}.</strong>
      <div style="margin-top: 5px;">
        O el pago todavía no llegó al banco, o entró por otro monto. Si aparece abajo con un
        monto distinto, hay que rechazar esta referencia y registrarla con el monto real del banco.
      </div>
    </div>

    <!-- Informativos: misma ventana de fechas, otro monto -->
    <div *ngIf="cercanos.length > 0" style="margin-top: 18px;">
      <div style="font-size: 0.75rem; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 8px;">
        Otros movimientos sin conciliar de esos días ({{ cercanos.length }}) — no se pueden emparejar
      </div>

      <div *ngFor="let c of cercanos"
        style="border: 1px dashed #e5e7eb; border-radius: 8px; padding: 9px 13px; margin-bottom: 6px; opacity: .75;">
        <div style="display: flex; justify-content: space-between; align-items: center; gap: 12px;">
          <div style="min-width: 0;">
            <div style="font-size: 0.8rem; color: #374151;">
              Ref. banco {{ c.referenciaBanco || '(sin referencia)' }}
            </div>
            <div style="font-size: 0.73rem; color: #9ca3af;">{{ c.descripcion }}</div>
          </div>
          <div style="text-align: right; white-space: nowrap;">
            <div style="font-weight: 700; color: #6b7280; font-size: 0.82rem;">{{ formatVES(c.monto) }}</div>
            <div style="font-size: 0.71rem; color: #9ca3af;">{{ c.fecha | date:'short' }}</div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px;">
    <button type="button" (click)="cerrar()" [disabled]="guardando"
      style="padding: 8px 16px; border: 1px solid #d1d5db; border-radius: 7px; background: #fff; color: #374151; font-size: 0.83rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button type="button" (click)="confirmar()"
      [disabled]="guardando || cargando || seleccionado === null"
      [style.opacity]="(guardando || cargando || seleccionado === null) ? .5 : 1"
      [style.cursor]="(guardando || cargando || seleccionado === null) ? 'not-allowed' : 'pointer'"
      style="padding: 8px 16px; border: none; border-radius: 7px; background: #1e5a3f; color: #fff; font-size: 0.83rem; font-weight: 700;">
      {{ guardando ? 'Emparejando…' : 'Emparejar y acreditar' }}
    </button>
  </div>

</div>
